<template>
  <section class="home-page01" @mousemove="mousemoveBG" ref="home-page01">
    <!-- bg -->
    <img
      class="bg"
      :style="moveStyle"
      src="../../assets/images/top/bg.png"
      alt
    />
    <img src="../../assets/images/top/slgon.png" class="slgon" alt />

    <!-- nav -->
    <home-nav class="left-nav"></home-nav>

    <div class="right-nav">
      <div class="pv-box">
        <span class="pv-box-tip">PV</span>
        <a
          v-for="(item, index) in pvList"
          :key="`pv-${index}`"
          @click="jumpTo(item.to)"
          :src="item.to"
          class="pv-box-a"
          >{{ item.text }}</a
        >
      </div>
      <div class="faction-box">
        <span class="faction-box-tip">CV</span>
        <a
          :href="item.href"
          class="faction-box-a"
          :class="{ active: item.open }"
          v-for="(item, index) in factionList"
          :key="`faction-${index}`"
        >
          <img :src="item.icon" alt />
        </a>
      </div>
      <div class="other-nav">
        <a
          :href="item.to"
          target="_blank"
          class="link-box"
          v-for="(item, index) in linkList"
          :key="`link-${index}`"
        >
          <img :src="item.icon" alt />
        </a>
      </div>
    </div>

    <!-- 修饰 -->
    <div class="logo-wrap">
      <a href="https://www.arknights.global/V-contest/IPORTATORIDEIVELLUTI/" target="_blank" rel="noopener noreferrer" class="logo" @click="go">
        <img src="../../assets/images/top/link_video8.png" alt />
      </a>
      <div class="setting">
        <!-- <a
            href="https://5thanniversary.arknights.global"
            target="_blank"
            rel="nofollow"
            class="banner"
          >
          <img src="../../assets/images/ad/collect-banner.png" alt="" />
        </a> -->
        <div class="download">
          <a
            href="https://apps.apple.com/us/app/id1464872022?mt=8"
            target="_blank"
            class="one"
          >
            <img src="../../assets/images/top/4.svg" alt />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.YoStarEN.Arknights "
            target="_blank"
            class="two"
          >
            <img src="../../assets/images/top/3.png" alt />
          </a>
          <!-- <a href="#" class="three">
            <img src="../../assets/images/top/2.png" alt />
          </a> -->
          <a
            href="https://play.google.com/googleplaygames/com.YoStarEN.Arknights?pcampaignid=dev-website-badge-en"
            target="_blank"
            class="four"
          >
            <img src="../../assets/images/top/1.png" alt />
          </a>
        </div>
      </div>

      <!-- <div class="pre-register-box">
                <a href="https://play.google.com/store/apps/details?id=com.YoStarEN.Arknights" target="_blank" class="pre-register">
                    <img src="../../assets/images/top/pre_register.png" class="pre-register--img" alt="">
                </a>
                <a href="https://apps.apple.com/us/app/id1464872022?mt=8" target="_blank" class="pre-register-ios">
                    <img src="../../assets/images/top/pre_register_ios.png" class="pre-register-ios--img" alt="">
                </a>
      </div>-->
    </div>

    <div class="scroll-box">
      <img src="../../assets/images/top/logo02.png" class="logo02" alt />
      <div class="mouse-box">
        <div class="mouse-tip">
          <img src="../../assets/images/top/mouse.png" class="mouse" alt />
        </div>
      </div>
    </div>

    <a
      href="https://ccvideocontest.arknights.global"
      target="_blank"
      class="link-video"
    >
      <img
        src="../../assets/images/top/link_video4.png"
        class="link-video-img"
        alt=""
      />
    </a>
  </section>
</template>

<script>
import homeNav from "../../components/nav";

export default {
  name: "home-page01",

  components: {
    "home-nav": homeNav,
  },
  data: () => ({
    moveStyle: "",
    pvList: [
      {
        text: "001",
        to: "https://www.youtube.com/watch?v=uySJpmfM7q4",
      },
      {
        text: "002",
        to: "https://www.youtube.com/watch?v=mvivPy7j6_Q",
      },
      {
        text: "003",
        to: "https://www.youtube.com/watch?v=Hfu_I0V3VrM&t=5",
      },
      {
        text: "004",
        to: "https://www.youtube.com/watch?v=zclYeBTcN7c",
      },
    ],
    linkList: [
      {
        icon: require("../../assets/images/top/link01.png"),
        to: "https://www.facebook.com/ArknightsGlobal",
      },
      {
        icon: require("../../assets/images/top/link02.png"),
        to: "https://twitter.com/ArknightsEN",
      },
      {
        icon: require("../../assets/images/top/link03.png"),
        to: "https://discord.gg/arknights",
      },
      {
        icon: require("../../assets/images/top/link04.png"),
        to: "https://www.youtube.com/channel/UCR0J2NYGuC8epsa1O4DMmXQ",
      },
      {
        icon: require("../../assets/images/top/link05.png"),
        to: "https://www.instagram.com/arknights_messenger_official",
      },
      {
        icon: require("../../assets/images/top/shop.png"),
        to: "https://yostar.store/collections/arknights",
      },
    ],
    factionList: [
      {
        icon: require("../../assets/images/top/faction01.png"),
        open: true,
        href: "https://www.youtube.com/watch?v=ZSgi1-QFETw",
      },
      {
        icon: require("../../assets/images/top/faction02.png"),
        open: true,
        href: "https://www.youtube.com/watch?v=NxehQJ1T2W8",
      },
      {
        icon: require("../../assets/images/top/faction03.png"),
        open: true,
        href: "https://www.youtube.com/watch?v=5amkbsiqbSw",
      },
      {
        icon: require("../../assets/images/top/faction04.png"),
        open: true,
        href: "https://www.youtube.com/watch?v=Zj9SD4eN-ug",
      },
      {
        icon: require("../../assets/images/top/faction05.png"),
        open: true,
        href: "https://www.youtube.com/watch?v=1XIHcLrYYeE ",
      },
      {
        icon: require("../../assets/images/top/faction06.png"),
        open: true,
        href: "https://www.youtube.com/watch?v=XjpS0AeC1sU",
      },
      {
        icon: require("../../assets/images/top/faction07.png"),
        open: true,
        href: "https://www.youtube.com/watch?v=abw8417s-vI&t=5s",
      },
    ],
  }),
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    mousemoveBG(event) {
      let x = event.offsetX;
      let y = event.offsetY;

      let boxW = this.$refs["home-page01"].clientWidth;
      let boxH = this.$refs["home-page01"].clientHeight;

      let centerX = Math.floor(boxW / 2);
      let centerY = Math.floor(boxH / 2);

      /* let tX = Math.round((centerX - x) / (boxW /2)* 10) / 100
            let tY = Math.round((centerY - y) / (boxH/2) * 10) / 100

            console.log(tX, tY)

            this.moveStyle = `transform: translate(${tX}%, ${tY}%)` */
      if (x <= centerX / 3 && y <= centerY / 3) {
        this.moveStyle = "transform: translate(-49%, 1%)";
      } else if (x <= centerX / 3 && y <= (centerY / 3) * 2) {
        this.moveStyle = "transform: translate(-49%, 0%)";
      } else if (x <= centerX / 3 && y <= centerY) {
        this.moveStyle = "transform: translate(-49%, -1%)";
      } else if (x <= (centerX / 3) * 2 && y <= centerY / 3) {
        this.moveStyle = "transform: translate(-50%, 1%)";
      } else if (x <= (centerX / 3) * 2 && y <= (centerY / 3) * 2) {
        // this.moveStyle = "transform: translate(-50%, 1%)"
      } else if (x <= (centerX / 3) * 2 && y <= centerY) {
        this.moveStyle = "transform: translate(-50%, -1%)";
      } else if (x <= centerX && y <= centerY / 3) {
        this.moveStyle = "transform: translate(-51%, 1%)";
      } else if (x <= centerX && y <= (centerY / 3) * 2) {
        this.moveStyle = "transform: translate(-51%, 0%)";
      } else if (x <= centerX && y <= centerY) {
        this.moveStyle = "transform: translate(-51%, -1%)";
      }
    },
    jumpTo(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    href() {
      window.location.href = 'https://pcsshortvideocontest.arknights.global/'
    },
    go() {
      gtag('event', 'click_banner')
    }
  },
};
</script>

<style lang="scss" scoped>
.home-page01 {
  background: linear-gradient(to bottom, #2c2e2f, #0c0c0c 12%);

  .link-video {
    position: absolute;
    width: pxTorem(750px);
    display: block;
    z-index: 999;
    left: 50%;
    transform: translateX(-50.5%);
    bottom: pxTorem(120px);

    .link-video-img {
      display: none;
      width: 100%;
    }
  }

  .bg {
    position: absolute;
    bottom: 0;
    width: 105%;
    z-index: 1;
    left: 50%;
    transform: translate(-50%, 0);
    transition: all 3s ease-in-out;
  }
  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../../assets/images/top/bg_texture.png");
    z-index: 3;
  }
  .slgon {
    width: pxTorem(940px);
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 23%;
    transform: translate(-50%, -50%);
  }
  .right-nav {
    position: absolute;
    z-index: 4;
    top: pxTorem(30px);
    right: pxTorem(26px);
    display: flex;
    // background: lightblue;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    font-family: "HelveticaInserat";

    .pv-box {
      color: #fff;
      font-size: 0;
      .pv-box-tip {
        font-size: pxTorem(16px);
      }
      .pv-box-a {
        font-size: pxTorem(18px);
        margin-left: pxTorem(12px);
        // opacity: 0.5;
        cursor: pointer;

        &:hover {
          opacity: 1;
          border-bottom: 2px solid #06a3da;
        }
      }
    }
    .faction-box {
      color: #fff;
      .faction-box-tip {
        font-size: pxTorem(16px);
      }
      .faction-box-a {
        width: pxTorem(40px);
        margin-left: pxTorem(12px);
        cursor: pointer;

        &.active {
          img {
            opacity: 1 !important;
          }
        }

        img {
          width: pxTorem(40px);
          opacity: 0.15;

          /* &:hover {
                        opacity: 1;
                    } */
        }
      }
    }
    .other-nav {
      width: pxTorem(38px);

      img {
        width: 100%;
      }
    }
  }
  .left-nav {
    position: absolute;
    z-index: 4;
    top: pxTorem(20px);
    left: pxTorem(12px);
  }

  .logo-wrap {
    width: pxTorem(355px);
    position: absolute;
    z-index: 4;
    left: 50%;
    transform: translateX(-50%);
    bottom: 3%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .logo {
      width: pxTorem(500px);
      position: relative;
      z-index: 10;
      top: pxTorem(200px);
      transform: translateX(1%);

      img {
        width: 100%;
      }
    }

    // .logo {
    //   width: 80%;
    //   position: relative;
    //   z-index: 10;
    //   top: pxTorem(2px);
    //   &::after {
    //     content: "";
    //     width: 100%;
    //     height: 100%;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     background: url("../../assets/images/top/logo_pr_active.png") no-repeat;
    //     background-size: 100%;
    //     opacity: 0;
    //     transition: all 0.3s ease-in-out;
    //   }

    //   &::before {
    //     content: "";
    //     width: 100%;
    //     height: 100%;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     // background: url("../../assets/images/top/logo_pr.png") no-repeat;
    //     background-size: 100%;
    //     opacity: 1;
    //     transition: all 0.3s ease-in-out;
    //   }

    //   img {
    //     width: 100%;
    //     opacity: 0;
    //   }

    //   &:hover {
    //     &::after {
    //       opacity: 1;
    //     }
    //     &::before {
    //       opacity: 0;
    //     }
    //   }
    // }
    .setting {
      top: pxTorem(-30px);
      position: relative;
      padding: pxTorem(16px) 0;
      // border-top: 1px solid #fff;
      // border-bottom: 1px solid #fff;
      .banner {
        display: block;
        width: pxTorem(700px);
        position: absolute;
        z-index: 1;
        top: pxTorem(-80px);
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .download {
        width: pxTorem(650px);
        height: pxTorem(272px);
        // background-color: rgba(0, 0, 0, 0.5);
        position: relative;
        a {
          position: absolute;
          img {
            width: pxTorem(200px);
            height: pxTorem(60px);
          }
        }
        .one {
          left: pxTorem(-10px);
          // left: pxTorem(100px);
          // top: pxTorem(11.2px);
          top: pxTorem(240px);
        }
        .two {
          // top: pxTorem(76.4px);
          left: pxTorem(215px);
          // left: pxTorem(340px);
          top: pxTorem(240px);
        }
        // .three {
        //   top: pxTorem(76px);
        // }
        .four {
          border-radius: pxTorem(9px);
          border: pxTorem(1px) solid #dfdcce;
          top: pxTorem(240px);
          right: pxTorem(1px);
          background: #000;
          img {
            width: pxTorem(194px);
            height: pxTorem(58px);
          }
        }
      }
    }

    // .pre-register-box {
    //     width: 100%;
    //     margin-top: pxTorem(40px);
    //     display: flex;
    //     justify-content: space-between;

    //     .pre-register {
    //         display: block;
    //         height: pxTorem(52px);

    //         .pre-register--img {
    //             display: block;
    //             height: 100%;
    //         }
    //     }
    //     .pre-register-ios {
    //         display: block;
    //         height: pxTorem(52px);

    //         .pre-register-ios--img {
    //             display: block;
    //             height: 100%;
    //         }
    //     }
    // }
  }
  .scroll-box {
    width: pxTorem(420px);
    position: absolute;
    z-index: 4;
    right: pxTorem(45px);
    bottom: 0%;

    .logo02 {
      width: 100%;
    }

    .mouse-box {
      width: pxTorem(30px);
      height: pxTorem(300px);
      position: relative;
      bottom: 0;
      left: pxTorem(200px);
      display: flex;
      flex-direction: column;
      // overflow: hidden;

      &::before {
        content: "";
        display: block;
        width: 2px;
        background: #fff;
        height: pxTorem(300px);
        position: relative;
        left: 50%;
        transform: translateX(-50%);
      }

      .mouse-tip {
        width: pxTorem(30px);
        position: relative;
        left: 50%;
        transform: translateX(-50%);

        .mouse {
          width: pxTorem(30px);
        }

        &::before {
          content: "scroll";
          position: absolute;
          transform-origin: left top;
          transform: translate(pxTorem(7px), pxTorem(90px)) rotateZ(90deg);
          color: #fff;
          text-transform: uppercase;
          font-size: pxTorem(14px);
        }

        &::after {
          content: "";
          display: block;
          width: 2px;
          background: #fff;
          height: pxTorem(280px);
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          animation: translt 3s linear infinite alternate;
        }

        @keyframes translt {
          0% {
            height: pxTorem(200px);
          }
          100% {
            height: pxTorem(20px);
          }
        }
      }
    }
  }
}
</style>
